export function usePaginationContext(): PaginationContext {
  const context = inject(PaginationContextKey);
  if (!context) throw new Error('usePaginationContext must be used inside <PaginationProvider>');
  return context;
}
